import { Button } from "@heroui/react"
import { ArrowRight, Award, Lightbulb, LucideIcon, PencilRuler, ThumbsUp } from "lucide-react"

const HowItWork = () => {
  const howItworkProcess = [
    {
      Icon: Lightbulb,
      title: "Concept & Request Letter of No Objection",
      description:
        "Submit Project Concept and request for a Letter of No Objection"
    },
    {
      Icon: ThumbsUp,
      title: "Design & Request Letter of Authorization",
      description:
        "Submit a Project Design Document and request a Letter of Authorization."
    },
    {
      Icon: PencilRuler,
      title: "Implementation & MRV",
      description:
        "Implement the project and submit MRV reports to track emission reductions."
    },
    {
      Icon: Award,
      title: "Verification & Credit Issuance",
      description: " MRV reports are verified, carbon credits issued, and the project is registered."
    }
  ]

  return (
    <div className="bg-primary-light py-5 md:py-20 px-5 lg:px-0" id="how-it-words">
      <div className="container mx-auto max-w-7xl">
        <header className="space-y-5 p-4 sm:p-0 max-w-2xl mx-auto text-center">
          <div className="space-y-2">
            <span className="text-xl md:text-2xl">LEARN</span>
            <h2 className="text-3xl md:text-4xl font-bold text-primary text-center">
              HOW IT WORKS
            </h2>
          </div>
          <div>
            <p className="text-center text-[20px]">
              The system is designed to around four simple key steps, ensuring that projects are properly validated, monitored, and verified
            </p>
          </div>
        </header>
        <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 my-12">
          {howItworkProcess.map(
            (
              item: { Icon: LucideIcon; title: string; description: string },
              index: number
            ) => {
              return (
                <div
                  className="bg-white shadow-lg border-2 border-base-200 text-center rounded-2xl p-6 h-96 flex flex-col justify-center items-center"
                  key={index}>
                  <div className="mb-5">
                    <item.Icon size={60} strokeWidth={1} className="text-primary" />
                  </div>
                  <div className="space-y-2">
                    <span className="text-lg md:text-xl opacity-60">STEP {index + 1}</span>
                    <p className="font-bold text-xl">{item?.title}</p>
                    <p>{item?.description}</p>
                  </div>
                </div>
              )
            }
          )}
        </div>
        <div className="flex justify-center">
          <Button
            as="a"
            size="lg"
            href="/how-it-works"
            color="primary"
            variant="bordered"
            endContent={<ArrowRight />}>
            Learn more
          </Button>
        </div>
      </div>
    </div>
  )
}

export default HowItWork
